import { render, staticRenderFns } from "./FormSelector.vue?vue&type=template&id=8c752546&scoped=true"
import script from "./FormSelector.vue?vue&type=script&lang=js"
export * from "./FormSelector.vue?vue&type=script&lang=js"
import style0 from "./FormSelector.vue?vue&type=style&index=0&id=8c752546&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c752546",
  null
  
)

export default component.exports